<template>
  <div class="brains-second-container">
    <div v-if="!previewActive" v-loading="loading" class="container-report-init"><previewInit /></div>
    <div v-else v-loading="loading" class="container-pages-preview">
      <div class="container-cerrar-pages-preview" @click="cerrarReports()">
        <div>{{ $t('close-report') }}</div><i class="el-icon-close" aria-hidden="true" />
      </div>
      <span id="container-col-pdf-data" class="container-col-pdf-data">
        <previewReportPage v-for="page in selectedReports" :key="page.id + '-' + actualZoom + '-' + geolevelselected.id" :init-print="imprimiendo" :page-data="page" />
      </span>
      <div v-if="errorReportsLevel || selectedReports.length === 0" class="container-alert-no-data">
        <el-alert :title="$t('chartsData.data-not-available-for-this-lvl')" type="warning" show-icon :closable="false" />
      </div>
    </div>
  </div>
</template>
<script>
import previewInit from '@/components/reportpreviewInit'
import previewReportPage from '@/components/reportpreviewReportPage'

import { mapState } from 'vuex'
export default {
  name: 'Reports',
  components: { previewInit, previewReportPage },
  data() {
    return {
      previewActive: false,
      loading: false,
      selectedReports: [],
      actualZoom: '',
      imprimiendo: false,
      errorReportsLevel: false
    }
  },
  computed: {
    selectedReportsOptions: {
      get() {
        return this.$store.state['reports'].selectedReportsOptions
      },
      set(value) {
        this.$store.dispatch('reports/setSelectedReportsOptions', { selectedReportsOptions: value })
      }
    },
    reportZoom: {
      get() {
        return this.$store.state['reports'].reportZoom
      }
    },
    ...mapState('location', {
      geolevelselected: (state) => state.geolevelselected,
      geolevels: (state) => state.geolevels
    })
  },
  watch: {
    geolevelselected(newOne, oldOne) {
      if (this.selectedReportsOptions.length > 0) {
        this.manageErrorReportsLevel()
      }
    }
  },
  created() {
    const vm = this
    vm.$root.$on('manageLoadingPrint', (status) => {
      vm.manageLoadingPrint(status)
    })
    vm.$root.$on('initPrint', (status) => {
      vm.initPrint(status)
    })
    vm.$root.$on('generarPreviewPDF', () => {
      vm.generarPreviewPDF()
    })
  },
  beforeDestroy() {
    // quitamos el emit
    const vm = this
    vm.$root.$off('manageLoadingPrint')
  },
  methods: {
    manageErrorReportsLevel() {
      var error = null
      this.selectedReportsOptions.forEach(item => {
        item.charts.forEach(chart => {
          if (chart.series.length === 0 && error !== false) {
            error = true
          } else {
            error = false
          }
        })

        if (this.geolevels[0].id !== 1 && error !== false && (item.id === 'unemployment' || item.id === 'new_dev')) {
          error = true
        }
      })

      this.errorReportsLevel = error
    },
    generarPreviewPDF() {
      this.manageErrorReportsLevel()
      this.previewActive = true
      this.selectedReports = []

      this.actualZoom = this.reportZoom
      this.selectedReports = this.selectedReportsOptions
    },
    manageLoadingPrint(value) {
      this.loading = value
    },
    initPrint(value) {
      this.imprimiendo = value
    },
    cerrarReports() {
      this.selectedReportsOptions = []
      this.previewActive = false
    }
  }
}
</script>

<style lang="scss" scoped>
.container-report-init {
  width: 100%;
  height: 85%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.container-pages-preview {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  height: calc(100vh - 126px);
  padding-top: 60px;
  position: relative;
  overflow: scroll !important;
}

.container-cerrar-pages-preview {
  position: absolute;
  right: 20px;
  top: 16px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 12px;
  align-items: center;
  color: rgb(194, 194, 194);
  cursor: pointer;
  font-family: "Montserrat-Light",sans-serif;

  i {
    font-size: 20px;
    align-self: start;
  }
}

.brains-second-container {
  width: 100%;
}
</style>
